import { useEffect } from "react";
import { TaskType, TaskTypeEnum } from "src/api/types";
import { useSentryLogger } from "src/hooks/useSentryLogger";
import { supabaseClient } from "src/supabase/supabaseClient";

export function usePriorAuthInsertSubscription(
  providerId: number | null,
  taskType: TaskTypeEnum,
  onSuccess: () => Promise<void>,
) {
  const errorLog = useSentryLogger("error");
  const log = useSentryLogger();

  useEffect(() => {
    if (taskType !== TaskType.PriorAuthRequest) return;

    if (providerId == null) return;

    let channel: ReturnType<typeof supabaseClient.channel> | undefined;

    (async () => {
      try {
        await supabaseClient.realtime.setAuth();

        channel = supabaseClient
          .channel(`prior_authorizations:provider:${providerId}`, {
            config: { private: true },
          })
          .on("broadcast", { event: "UPDATE" }, () => {
            onSuccess();
          })
          .subscribe((status, error) => {
            if (error != null) {
              errorLog("PA subscribe error:", error);
            } else {
              log("PA subscribe status:", status);
            }
          });
      } catch (err) {
        errorLog("Error with prior auth realtime subscription", err);
      }
    })();

    return () => {
      if (channel) {
        supabaseClient.removeChannel(channel);
      }
    };
  }, [errorLog, log, onSuccess, providerId, taskType]);
}
